<template>
    <span class="nk-menu-text">
        <span class="nk-menu-title">{{ resolvedLabel }}</span>
        <span v-if="resolvedSubtext" class="nk-menu-subtext">{{ resolvedSubtext }}</span>
    </span>
</template>

<script>
import { getMenuSubtext } from './menu-subtitles'

export default {
    name: 'MenuItemText',
    props: {
        menuKey: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
    },
    computed: {
        resolvedLabel() {
            if (this.label) {
                return this.label
            }
            if (this.menuKey) {
                return this.trans(this.menuKey)
            }
            return ''
        },
        resolvedSubtext() {
            if (this.menuKey) {
                return getMenuSubtext(this.menuKey)
            }
            if (this.label) {
                return getMenuSubtext(this.label)
            }
            return ''
        },
    },
}
</script>
